<template>
	<div>
		<div class="row">
			<div class="col-md-5 col-12 mt-2">
				<h3>Territory Trend Sales</h3>
				<h6>Choose 1 Dealer To Use This Feature</h6>
			</div>
			<div class="col-md-3 col-6 mt-2 wrapHighlight">
				<Multiselect
					:options="filterData.dealer.map((x) => x.code)"
					:custom-label="
						(opt) =>
							filterData.dealer.find((x) => x.code == opt).name
					"
					placeholder="Select 1 Dealer"
					:allow-empty="false"
					v-model="filter.dealer"
				/>
			</div>
			<div class="col-md-2 col-3 mt-2">
				<Multiselect
					:options="filterData.trendType"
					:allow-empty="false"
					v-model="showType"
				/>
			</div>
			<div class="col-md-2 col-3 mt-2">
				<button
					class="btn w-100 btn-secondary"
					style="height:40px"
					@click="downloadExcel"
				>
					Download CSV
				</button>
			</div>
		</div>

		<div v-if="dataTable" class="mt-4">
			<div
				v-if="showType == 'by Table'"
				style="width:100%;overflow-x:scroll"
			>
				<table class="table text-center table-bordered" id="table">
					<thead style="border-bottom: 1px solid grey">
						<tr>
							<th class="freezeCol" style="margin-top:0.5px"></th>
							<template v-for="month in dataTable">
								<th colspan="3">{{ month.bulan }}</th>
							</template>
						</tr>
						<tr>
							<th class="freezeCol" style="height:54px">Ring</th>
							<template v-for="month in dataTable">
								<th style="min-width:100px;">Sales</th>
								<th style="min-width:100px;">% Contribution</th>
								<th style="min-width:100px;">Growth</th>
							</template>
						</tr>
					</thead>
					<!-- <tbody v-for="(data, index) in dataTable" :key="data.bulan + index">
						<template v-for="object in Object.keys(data)">
							<tr v-if="object != 'bulan'" :key="object + data.bulan">
								<td>{{capitalize(object.toLowerCase())}}</td>
							</tr>
						</template>
					</tbody> -->
					<tbody
						v-for="object in Object.keys(dataTable[0])"
						:key="object"
					>
						<template
							v-if="
								object != 'bulan' &&
									!(
										object.includes('Sales') ||
										object.includes('Percentage')
									)
							"
						>
							<tr>
								<td class="h6 freezeCol">
									{{ capitalize(object.toLowerCase()) }}
								</td>
								<template v-for="(data, index) in dataTable">
									<td :key="object + data.bulan + index">
										<span class="h6">{{
											numberWithCommas(data[object].sales)
										}}</span>
									</td>
									<td
										:key="
											object +
												data.bulan +
												index +
												'percent'
										"
									>
										<span
											class="ml-2"
											:class="{
												'text-red':
													parseFloat(
														data[object].percent
													) < 0,
												'text-green':
													parseFloat(
														data[object].percent
													) > 0,
											}"
										>
											{{
												parseFloat(
													data[object].percent
												) > 0
													? "+"
													: "-"
											}}
											{{
												Math.abs(
													parseFloat(
														data[object].percent
													)
												)
											}}
											%
										</span>
									</td>
									<td
										:key="
											object +
												data.bulan +
												index +
												'growth'
										"
									>
										<span
											class="ml-2"
											:class="{
												'text-red':
													parseFloat(
														data[object].growth
													) < 0,
												'text-green':
													parseFloat(
														data[object].growth
													) > 0,
											}"
										>
											{{
												parseFloat(
													data[object].growth
												) > 0
													? "+"
													: "-"
											}}
											{{
												Math.abs(
													parseFloat(
														data[object].growth
													)
												)
											}}
											%
										</span>
									</td>
								</template>
							</tr>
						</template>
					</tbody>
					<tbody v-if="salesRef">
						<tr>
							<td class="h6 freezeCol">Total</td>
							<template v-for="total in salesRef">
								<td>{{ total.sales }}</td>
								<td 
									:class="{
										'text-red':
											parseFloat(
												total.percent
											) < 0,
										'text-green':
											parseFloat(
												total.percent
											) > 0,
									}"
								>
									{{
										parseFloat(total.percent) > 0
											? "+"
											: "-"
									}}
									{{ Math.abs(parseFloat(total.percent)) }} %
								</td>
								<td
									:class="{
										'text-red':
											parseFloat(
												total.growth
											) < 0,
										'text-green':
											parseFloat(
												total.growth
											) > 0,
									}"
								>
									<!-- {{
										parseFloat(total.growth) > 0 ? "+" : "-"
									}}
									{{ Math.abs(parseFloat(total.growth)) }} % -->
								</td>
							</template>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-else>
				<TrendSalesLineChart :data="formattedData" />
			</div>
		</div>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import TrendSalesLineChart from "./children/TrendSalesLineChart.vue";
import XLSX from "xlsx";
import moment from "moment";

export default {
	components: {
		Multiselect,
		TrendSalesLineChart,
	},
	data() {
		return {
			filter: {
				dealer: null,
			},
			showType: "by Table",
			dataTable: null,
			formattedData: null,
			filterData: {
				trendType: ["by Table", "by Line Chart"],
				dealer: this.$store.getters.getDealer(null, null),
			},
			salesRef: null,
		};
	},
	watch: {
		"filter.dealer": function() {
			this.loadApi();
		},
	},
	mounted() {
		this.loadApi();
	},
	methods: {
		downloadExcel() {
			// var wb = XLSX.utils.table_to_book(document.getElementById('table'), {sheet:"Data"});

			let keys = Object.keys(this.formattedData[0]);

			let arrRing = ["LOKASI", "OTHER", "RING 1", "RING 2", "RING 3"];
			// let data = new Array(arrRing.length).fill({})
			let data = [
				{
					Ring: arrRing[0],
				},
				{
					Ring: arrRing[1],
				},
				{
					Ring: arrRing[2],
				},
				{
					Ring: arrRing[3],
				},
				{
					Ring: arrRing[4],
				},
			];
			for (var j = 0; j < this.formattedData.length; j++) {
				for (var i = 0; i < data.length; i++) {
					let changePercentage = parseFloat(
						this.formattedData[j][data[i]["Ring"] + "Percentage"]
					);
					data[i][
						this.formattedData[j].bulan + " - Sales"
					] = this.formattedData[j][data[i]["Ring"] + "Sales"];
					data[i][this.formattedData[j].bulan + " - Change %"] =
						changePercentage > 0
							? "+ " + changePercentage
							: changePercentage;
				}
			}

			let wb = XLSX.utils.book_new();
			let ws1 = XLSX.utils.json_to_sheet(data, { raw: true });
			XLSX.utils.book_append_sheet(wb, ws1, "Trend Sales");

			XLSX.writeFile(wb, "Trend Sales.xlsx");
		},
		loadApi() {
			if (!this.filter.dealer) return;
			this.dataTable = null;

			this.$http
				.get(
					`/api/h1/territory-trend-sales/?dealer=${this.filter.dealer}`
				)
				.then((resp) => {
					let data = resp.data.data;
					this.dataTable = Object.assign([], data);
					let formattedData = Object.assign([], data);

					this.calculateTotal(data);

					for (var i = 0; i < formattedData.length; i++) {
						let keys = Object.keys(formattedData[i]);
						// keys.push('total')

						for (var j = 0; j < keys.length; j++) {
							if (keys[j] == "bulan") continue;

							formattedData[i][keys[j] + "Sales"] =
								formattedData[i][keys[j]].sales;

							formattedData[i][keys[j] + "Percentage"] =
								formattedData[i][keys[j]].percent;
						}
					}
					this.formattedData = formattedData;
				})
				.catch((err) => {
					console.log(err);
					// this.$store.dispatch('triggerAlert' , [false , 'Something went wrong while loading the api. Please try again later.'])
				});
		},
		calculateTotal(data) {
			this.salesRef = [];
			for (var i = 0; i < data.length; i++) {
				let curData = data[i];
				let keys = Object.keys(curData);

				let total = {
					sales: 0,
					percent: 0,
					growth: 0,
				};

				for (var j = 0; j < keys.length; j++) {
					let curKeys = keys[j];
					if (curKeys == "bulan") continue;

					total.sales += curData[curKeys].sales;
					total.percent += parseFloat(curData[curKeys].percent);
					total.growth += parseFloat(curData[curKeys].growth);
				}

				this.salesRef.push(total);
			}
		},
	},
};
</script>

<style scoped>
.text-red {
	color: red;
}
.text-green {
	color: green;
}
td {
	height:50px;
	width:100px;
}

.freezeCol  {
	position:absolute; 
	width:101px;
 
	height:50px;

	background-color: white;
	margin-top:-1.5px;
	margin-left:-1px;
	/* top:auto; */
	/* border-right: 0px none black;  */
	/* border-top-width:3px; only relevant for first row */
	/* margin-top:-3px; compensate for top border */
}
</style>
